import { render, staticRenderFns } from "./IconMoveFile.vue?vue&type=template&id=5d83f5b3&"
import script from "./IconMoveFile.vue?vue&type=script&lang=js&"
export * from "./IconMoveFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d83f5b3')) {
      api.createRecord('5d83f5b3', component.options)
    } else {
      api.reload('5d83f5b3', component.options)
    }
    module.hot.accept("./IconMoveFile.vue?vue&type=template&id=5d83f5b3&", function () {
      api.rerender('5d83f5b3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconMoveFile.vue"
export default component.exports